"use strict";

var nameSpace = "slider";

/**
 * [dataAttrOptions extends default options with options defined in namespaced data attr.]
 * @param  {[object]} defaults [Default extend object]
 * @param  {[object]} options  [Extend to defaults]
 * @return {[object]}          [extended object]
 */
function dataAttrOptions(defaults, options) {
    var dataOptions = {},
        settings = {};

    if (jQuery.isEmptyObject(options)) {
        return defaults;
    }

    for (let key in options) {
        if (key.includes(nameSpace)) {
            let stripedKey = key.replace(nameSpace, "");
            let newKey = stripedKey[0].toLowerCase() + stripedKey.slice(1);

            dataOptions[newKey] = options[key];
        }
    }

    // Recursively merge defaults and data attribute options.
    settings = $.extend(true, {}, defaults, dataOptions);

    return settings;
}

/**
 * [heroSlider makes a slider with single item inview]
 * @param  {[string]} scope     [css selector]
 * @return {[undefined]}        [nothing returned]
 */

// ImageSlider Module
export function heroSlider(scope) {
    var defaults = {
        items: 1,
        loop: true,
        margin: 0,
        mouseDrag: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        animateOut: "sliderFadeOut",
        animateIn: "sliderFadeIn",
        fallbackEasing: "swing",
        nav: true,
        responsive: {
            767: {
                nav: false,
            },
            768: {
                nav: true,
            },
        },
    };

    var elm = $(scope);

    if (elm.find(".slide-item").length <= 1) {
        return;
    }

    var settings = dataAttrOptions(defaults, elm.data());

    elm.owlCarousel(settings);
}

/**
 * [listSlider makes a slider with a list of items inview]
 * @param  {[string]} scope     [css selector]
 * @return {[undefined]}        [nothing returned]
 */

// RecentNews Module
export function listSlider(scope) {
    var defaults = {
        items: 2,
        loop: false,
        margin: 30,
        mouseDrag: true,
        nav: true,
        dots: false,
        autoplay: false,
        responsive: {
            0: {
                items: 1,
                dots: true,
                nav: false,
            },
            430: {
                items: 2,
                dots: true,
                nav: false,
            },
            767: {
                items: 2,
            },
            950: {
                items: 3,
            },
            1190: {
                items: 3,
            },
        },
    };

    var elm = $(scope);
    var settings = dataAttrOptions(defaults, elm.data());

    elm.owlCarousel(settings);
}

/**
 * [init initilizes all sliders]
 * @param  {[object]} scopes    [a object keys as function names and value as selectors]
 * @return {[undefined]}        [nothing returned]
 */
export function init(scopes) {
    var defaults = {
        items: 1,
        loop: true,
        margin: 30,
        mouseDrag: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        animateOut: "sliderFadeOut",
        animateIn: "sliderFadeIn",
    };

    var elm = $(".slider--medium");
    var settings = dataAttrOptions(defaults, elm.data());

    if (elm.find(".slide-item").length >= 1) {
        elm.owlCarousel(settings);
    }

    var defaults2 = {
        items: 2,
        loop: false,
        margin: 30,
        mouseDrag: true,
        nav: false,
        dots: false,
        autoplay: false,
        autoWidth: false,
        responsive: {
            0: {
                autoWidth: true,
                margin: 10,
                items: 1,
                loop: true,
                stagePadding: 100,
            },
            400: {
                autoWidth: true,
                margin: 10,
                items: 1,
                loop: true,
                stagePadding: 100,
            },
            500: {
                autoWidth: true,
                margin: 10,
                items: 2,
                loop: true,
                stagePadding: 100,
            },
            768: {
                items: 2,
            },
            840: {
                items: 3,
            },
            1070: {
                items: 4,
            },
        },
    };

    var elm2 = $(".products.product--large");
    var settings2 = dataAttrOptions(defaults2, elm.data());

    elm2.owlCarousel(settings2);

    for (let scope in scopes) {
        this[scope].call(this, scopes[scope]);
    }
}
